/** Tooltip van de slotknop op een volgend paneel (zwevende kop en dock-chip). */
export function floatingPanelLockTooltip(label: string): string {
  return `Volgt de actieve tab. Klik om te vergrendelen op ${label}`;
}

/** Tooltip van de slotknop op een vergrendeld paneel. */
export function floatingPanelUnlockTooltip(label: string): string {
  return `Vergrendeld op ${label}. Klik om weer de actieve tab te volgen`;
}
